import { z } from 'zod';
import { Email, IsoDateTime, Uuid } from './common.js';
/**
 * Module `omp-link` (docs/modules/omp-link.md, spec 9.1, handover contract docs/integrations/omp-link.md).
 * Off by default. Owner: task S19.
 */
export const OmpLinkTenantSettings = z.object({
    /** OMP's base URL for webhooks, e.g. https://omp.example.com/api/cloudsign/webhook */
    webhookUrl: z.string().max(2000).default(''),
    /** Where "OMP can't be reached" alerts go; empty = the tenant's admin contact. */
    alertEmail: z.string().max(254).default(''),
    /** Minutes unreachable before the alert (spec 9.1 rule 8). */
    alertAfterMinutes: z.number().int().min(1).max(1440).default(10),
    /** Group OMP sign-ins go to when the person isn't told otherwise (a repeat group, e.g. Staff). */
    defaultGroupId: Uuid.nullable().default(null),
});
export const OmpLinkStatus = z.object({
    configured: z.boolean(),
    apiClientId: Uuid.nullable(),
    apiKeyId: z.string().nullable(),
    webhookEndpointId: Uuid.nullable(),
    webhookStatus: z.enum(['active', 'paused', 'failing']).nullable(),
    failingSince: IsoDateTime.nullable(),
    lastOutboundAt: IsoDateTime.nullable(),
    lastInboundAt: IsoDateTime.nullable(),
    linkedSites: z.number().int(),
    linkedPeople: z.number().int(),
    unmatchedPeople: z.number().int(),
});
/** POST /omp-link/connect: creates (or re-creates) the API client and the webhook endpoint; secrets shown once. */
export const OmpLinkConnect = z.object({ webhookUrl: z.url().max(2000), alertEmail: Email.nullable().default(null), defaultGroupId: Uuid });
export const OmpLinkConnectResult = z.object({ apiKey: z.string(), webhookSecret: z.string(), status: OmpLinkStatus });
export const OmpSiteLink = z.object({ siteId: Uuid, siteName: z.string(), ompOfficeId: z.string().nullable() });
export const OmpSiteLinksUpdate = z.object({ links: z.array(z.object({ siteId: Uuid, ompOfficeId: z.string().trim().max(100).nullable() })).max(500) });
/** One line of the "latest messages" log: outbound webhooks and inbound API calls, newest first. */
export const OmpMessage = z.object({
    at: IsoDateTime,
    direction: z.enum(['outbound', 'inbound']),
    type: z.string(),
    status: z.string(),
    personName: z.string().nullable(),
    siteName: z.string().nullable(),
    detailKey: z.string().nullable(),
});
export const OmpTestResult = z.object({ ok: z.boolean(), statusCode: z.number().int().nullable(), errorKey: z.string().nullable(), durationMs: z.number().int() });
//# sourceMappingURL=omp-link.js.map